<template>
<div class="card-box-full">
  <div class="card-box-header">
    Admin Page
  </div>

  <table style="margin-top: 10px; font-size: 13px">
    <tr>
      <td>
        <CButton @click="openURL('https://github.com/BendingSpoons/command-center')" color="info" style="width: 100%; margin-top: 5px">
          <CIcon name="cib-github" style="margin-right: 2px" /> GitHub Repo
        </CButton>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <CButton @click="openURL('https://icons.coreui.io/icons/')" color="secondary" style="width: 100%; margin-top: 5px">
          <CIcon name="cil-external-link" style="margin-right: 2px" /> CoreUI Icons
        </CButton>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <CButton @click="openURL('https://coreui.io/vue/demo/4.0/free/#/dashboard')" color="secondary" style="width: 100%; margin-top: 5px">
          <CIcon name="cil-external-link" style="margin-right: 2px" /> CoreUI Demo
        </CButton>
      </td>
      <td>
      </td>
    </tr>
  </table>

</div>
</template>

<script>
export default {
  name: 'Admin-Page',
  methods: {
    //--------------------------------------------------------------------------
    openURL(url) {
      window.open(url, '_blank');
    }
  }
}
</script>
